for (let i = 0; i <= 20; i++) {
  if (localStorage.getItem(`history-${i}`)) {
    const query = `{
      products(first: 10, query: "id:${localStorage.getItem("history-" + i)}") {
        edges {
          node {
            title,
            id,
            handle,
            variants(first: 1) {
              edges {
                node {
                  image {
                    originalSrc
                  },
                  priceV2 {
                    amount
                  },
                }
              }
            }
          }
        }
      }
    }`;

    apiCall(query).then((response) => {
      const title = response.data.products.edges[0].node.title;
      const id = response.data.products.edges[0].node.id;
      const handle = response.data.products.edges[0].node.handle;
      const image = response.data.products.edges[0].node.variants.edges[0].node.image.originalSrc;
      const price = response.data.products.edges[0].node.variants.edges[0].node.priceV2.amount;
      if (document.getElementById("item") !== null) {
        if (localStorage.getItem(`history-${i}`) !== document.getElementById("item").dataset.productId) {
          document.getElementById("historyItems").innerHTML = generateItem(handle, image, title, price);
        }
      } else {
        document.getElementById("historyItems").innerHTML = generateItem(handle, image, title, price);
      }
    });

    async function apiCall(query) {
      const response = await fetch("https://ikenohata-ginkawaten.myshopify.com/api/2020-10/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": "21d21708a27a28e8dfebdfb7fe7c46d6",
        },
        body: query,
      });
      return await response.json();
    }
  }
}

function generateItem(handle, image, title, price) {
  let itemUrl = `/products/${handle}/`;
  if (document.getElementById("historyItemsCn")) {
    itemUrl = `/zh-cn/products/${handle}/`;
  }

  if (document.getElementById("historyItemsJa")) {
    const innerHtml = `${document.getElementById("historyItems").innerHTML}
    <a href="${itemUrl}" class="items__box swiper-slide">
      <img src="${image}" alt="商品画像" class="items__img" width="320" height="320">
      <div class="items__info">
        <p class="items__title">${title}</p>
        <p class="items__price">&yen;${Math.floor(price).toLocaleString()}(税込)</p>
      </div>
    </a>`;
    return innerHtml;
  } else {
    const innerHtml = `${document.getElementById("historyItems").innerHTML}
    <a href="${itemUrl}" class="items__box swiper-slide">
      <img src="${image}" alt="商品画像" class="items__img" width="320" height="320">
    </a>`;
    return innerHtml;
  }
}

setTimeout(() => {
  // const historyItemsHtml = document.getElementById("historyItems").innerHTML;
  // document.getElementById("historyItems").innerHTML = historyItemsHtml + historyItemsHtml + historyItemsHtml + historyItemsHtml;

  const historySlider = new Swiper("#historySlider", {
    slidesPerView: 2,
    speed: 1000,
    spaceBetween: 15,

    autoplay: {
      delay: 3000,
    },

    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 38,
      },
    },

    pagination: {
      el: "#history-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: "#history-next",
      prevEl: "#history-prev",
    },
  });
}, 200);
